/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import Component from 'inferno-component';
// styles
import styles from 'components/shared/checkbox/checkbox_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ CHECKBOX ~~~~~~~~~~ ========== */
const Checkbox = props => (
    <div className={`${sheet.classes.checkboxwrapper} checkboxwrapper`}>
        {/*
        	<input className={`${sheet.classes.checkbox} checkbox`} type="checkbox" {...props} />
        	<span className={`${sheet.classes.text} text`}>{props.text}</span>
        */}
        <input
            type="checkbox"
            className={`styled-checkbox ${props.valid ? 'valid' : 'invalid'}`}
            onChange={props.onChange}
            disabled={props.disabled}
        />
    	<label>{props.text}</label>
    </div>
)



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Checkbox;
